import { IList, IRectSize } from 'annotation-tools/utils';
import { IImageInfo, IImageInfoType } from '../../../types/record/image-info';
import { RawRectangleToIRect } from '../../types/common/raw-rectangle';
import {
  IImageInfoAPIValidationErrorFactory,
  ImageInfoAPIRawSuccessResponseType,
  ImageInfoAPIRawValidationErrorType,
  ImageInfoAPIValidationErrorType
} from '../../types/image-info/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IImageInfoFromAPISuccessResponse = ({
  id,
  file,
  name,
  width,
  height,
  crop_option,
  annotation_count,
  is_annotated
}: ImageInfoAPIRawSuccessResponseType): IImageInfoType =>
  IImageInfo({
    id,
    fileUri: file,
    name,
    size: IRectSize({ width, height }),
    cropRect: RawRectangleToIRect(crop_option),
    numAnnotations: annotation_count,
    isAnnotated: is_annotated
  });

export const IImageInfoListFromAPISuccessResponse = (
  list: ImageInfoAPIRawSuccessResponseType[]
): IList<IImageInfoType> =>
  IList<IImageInfoType>(list.map(IImageInfoFromAPISuccessResponse));

export const IImageInfoAPIValidationError = ({
  file_guid,
  crop_option
}: ImageInfoAPIRawValidationErrorType): ImageInfoAPIValidationErrorType =>
  IImageInfoAPIValidationErrorFactory({
    fileGuid: nullableToStringList(file_guid),
    cropRect: nullableToStringList(crop_option)
  });
